export default "__VITE_ASSET__DVQCX63l__"